export * from "./OtpComponent";
